import _ from 'lodash';

/**
 * CORS proxy to use in requests
 * @type {string}
 */
export const CORS_PROXY = 'https://cors-anywhere.herokuapp.com/';

export default class AppsService {
  constructor($http, SeldaAPIService) {
    'ngInject';
    Object.assign(this, {$http, SeldaAPIService});
  }

  digitalAgenda() {
    return this.$http.get(`${CORS_PROXY}http://agendadigitale.federmanager.it/api/?method=last-posts`).then((r) => r.data);
  }

  projectManager(id) {
    return this.$http.get(`${CORS_PROXY}http://progettomanager.federmanager.it/read/api/?method=issue&get=${id}`)
      .then((r) => _(r.data.articles).filter('indexed')
        .map((a) => _.extend(a, {image: a.img_url}))
        .value());
  }

  projectManagerIssues() {
    return this.$http.get(`${CORS_PROXY}http://progettomanager.federmanager.it/read/api/?method=list-issues&listonly`)
      .then((r) => r.data);
  }

  videoFeed() {
    let videosUrl = 'https://www.googleapis.com/youtube/v3/search?key=AIzaSyC6YZ5ksJqgefFjuH4On2xy9Aw86UogOAw&channelId=UCIG-fwQ76W37ZFEujJYZJmQ&maxResults=50&part=snippet%2Cid&order=date&callback=JSON_CALLBACK&forUsername=Federmanager';
    return this.$http.jsonp(videosUrl).then((r) => r.data.items);
  }
}


// WEBPACK FOOTER //
// ./client/app/services/apps_service.js